import { ChatDiscussion } from '../entity';

export class ChatDiscussionAddedEvent {
  constructor(public discussions: ChatDiscussion[]) {}
}
